import React from "react";
import LegalLayout from "./LegalLayout";
import useSeo from "@/hooks/useSeo";

export default function Terms() {
  useSeo({
    title: "Termini di servizio",
    description: "Termini e condizioni d'uso di Autofattura by Dasabo. Servizio SaaS per la generazione di autofatture estere. Emittente DASABO SRL, Palermo. Foro competente: Palermo.",
    path: "/terms",
  });
  return (
    <LegalLayout
      testid="legal-terms"
      kicker="Legal"
      title="Termini e condizioni di servizio"
      updatedAt="27 febbraio 2026"
    >
      <div className="callout">
        <p>
          <strong>Sintesi non giuridica.</strong> Autofattura è uno strumento software di supporto
          per la generazione di autofatture per acquisti da fornitori esteri. Il servizio automatizza
          operazioni ma <strong>non sostituisce il commercialista</strong>, non presta consulenza fiscale
          e <strong>non garantisce</strong> la correttezza, completezza o idoneità fiscale dei documenti
          prodotti. La responsabilità della verifica e della trasmissione allo SDI resta
          <strong> integralmente dell&apos;utente</strong>.
        </p>
      </div>

      <h2>1. Titolare del servizio</h2>
      <p>
        Il servizio &laquo;<strong>Autofattura</strong>&raquo; (di seguito, il &laquo;<strong>Servizio</strong>&raquo;)
        è offerto da <strong>DASABO SRL</strong>, con sede legale in Via Imperatore Federico 100,
        90143 Palermo (PA), Italia, P.IVA e Codice Fiscale 07407380828, PEC dasabo@pec.it
        (di seguito, &laquo;<strong>DASABO</strong>&raquo; o il &laquo;<strong>Fornitore</strong>&raquo;).
      </p>

      <h2>2. Oggetto</h2>
      <p>
        I presenti Termini disciplinano l&apos;utilizzo del Servizio, che consente all&apos;utente di:
        (i) caricare documenti PDF di fornitori esteri; (ii) estrarre automaticamente i dati tramite
        modelli di intelligenza artificiale di terze parti; (iii) generare file XML in formato FatturaPA
        (TD17/TD18/TD19); (iv) opzionalmente trasmettere tali file allo SDI mediante integrazioni con
        intermediari terzi (Fatture in Cloud, OpenAPI.it, ecc.).
      </p>

      <h2>3. Accettazione</h2>
      <p>
        L&apos;iscrizione e/o l&apos;utilizzo del Servizio comportano l&apos;accettazione integrale e
        senza riserve dei presenti Termini. L&apos;utente dichiara di essere maggiorenne, di agire
        nell&apos;esercizio di attività professionale o d&apos;impresa e di possedere i requisiti fiscali
        per emettere autofatture ai sensi della normativa italiana.
      </p>

      <h2>4. Natura del Servizio · Assenza di consulenza</h2>
      <p>
        Il Servizio è un <strong>mero strumento software</strong>. DASABO non è un intermediario
        fiscale, non svolge attività di consulenza tributaria, contabile o legale, non è iscritto
        all&apos;albo dei dottori commercialisti né dei consulenti del lavoro, e non presta il proprio
        parere sulla qualificazione fiscale delle operazioni dell&apos;utente.
      </p>
      <p>
        Ogni codice natura, codice tipo documento (TD17/TD18/TD19), aliquota IVA, riferimento
        normativo o calcolo mostrato dal Servizio ha valore <strong>puramente indicativo</strong> ed è
        soggetto a verifica da parte dell&apos;utente e/o del suo consulente fiscale prima della
        trasmissione allo SDI.
      </p>

      <h2>5. Assenza di garanzie</h2>
      <p>
        Il Servizio è fornito &laquo;<strong>as-is</strong>&raquo; e &laquo;<strong>as-available</strong>&raquo;.
        Nella misura massima consentita dalla legge, DASABO <strong>esclude ogni garanzia</strong>,
        espressa o implicita, incluse a titolo esemplificativo:
      </p>
      <ul>
        <li>garanzie di idoneità a un uso specifico;</li>
        <li>garanzia di correttezza, completezza, aggiornamento o accuratezza dei dati estratti
        dai PDF caricati dall&apos;utente;</li>
        <li>garanzia di conformità del file XML al tracciato ministeriale vigente al momento
        della trasmissione;</li>
        <li>garanzia di consegna del file allo SDI, di corretta ricezione da parte
        dell&apos;Agenzia delle Entrate, o di assenza di scarti (esiti NS/MC/DT);</li>
        <li>garanzia di continuità operativa, assenza di interruzioni, bug, tempi di risposta o
        assenza di errori dell&apos;infrastruttura, dei modelli AI o dei fornitori terzi (es.
        Fatture in Cloud, OpenAPI.it, Resend, provider cloud);</li>
        <li>garanzia che il Servizio sia esente da vulnerabilità, virus o attacchi informatici.</li>
      </ul>

      <h2>6. Responsabilità dell&apos;utente</h2>
      <p>L&apos;utente è unico ed esclusivo responsabile di:</p>
      <ul>
        <li><strong>verificare integralmente</strong> ogni autofattura generata prima della sua
        trasmissione allo SDI, in particolare i dati identificativi del fornitore estero
        (denominazione, VAT, indirizzo, Paese), l&apos;importo imponibile, il codice natura,
        il codice tipo documento e il regime fiscale applicato;</li>
        <li>assicurarsi che le proprie configurazioni fiscali (P.IVA, codice destinatario/PEC,
        regime, sezionale, numerazione) siano corrette e aggiornate;</li>
        <li>rispettare i termini di legge per l&apos;emissione delle autofatture (in generale, entro
        il 15° giorno del mese successivo al ricevimento della fattura estera, salvo diversa
        disciplina);</li>
        <li>conservare digitalmente a norma i documenti prodotti, o incaricare un intermediario
        autorizzato alla conservazione;</li>
        <li>presidiare l&apos;area di lavoro (login, credenziali, sessione) e le proprie
        integrazioni di terze parti;</li>
        <li>rispettare le disposizioni fiscali, penali e tributarie applicabili.</li>
      </ul>

      <h2>7. Limitazione di responsabilità</h2>
      <p>
        Nella misura massima consentita dalla legge, DASABO <strong>non risponde</strong> in alcun caso:
      </p>
      <ul>
        <li>di sanzioni, interessi, contestazioni, accertamenti o ravvedimenti irrogati
        dall&apos;Agenzia delle Entrate o da altra autorità in relazione ad autofatture generate
        o trasmesse tramite il Servizio;</li>
        <li>di perdita di dati, di mancato guadagno, di danni indiretti, incidentali o
        consequenziali, ivi inclusi danni reputazionali;</li>
        <li>di errori, omissioni o allucinazioni dei modelli AI di terze parti utilizzati per
        l&apos;estrazione dei dati dai PDF (a titolo esemplificativo: Anthropic Claude, OpenAI GPT,
        Google Gemini);</li>
        <li>di malfunzionamenti, latenze, rifiuti o comportamenti anomali degli intermediari
        SDI di terze parti;</li>
        <li>di scarti dello SDI riconducibili a dati imprecisi contenuti nel PDF di origine, a
        configurazioni errate dell&apos;utente, o a modifiche del tracciato XML ministeriale;</li>
        <li>di eventi di forza maggiore, tra cui, a titolo non esaustivo: fermi
        infrastrutturali di terzi (Cloudflare, AWS, MongoDB Atlas), attacchi cyber, blackout,
        provvedimenti autoritativi, indisponibilità dell&apos;Agenzia delle Entrate.</li>
      </ul>
      <p>
        In ogni caso, e a prescindere dal titolo (contrattuale, extracontrattuale, precontrattuale
        o altro), la responsabilità complessiva di DASABO nei confronti dell&apos;utente per
        qualsiasi pretesa, cumulata su base annua, è <strong>limitata al corrispettivo effettivamente
        versato</strong> dall&apos;utente nei 12 mesi precedenti l&apos;evento generatore del danno,
        con un massimale che non potrà comunque superare euro 100 (cento).
      </p>

      <h2>8. Manleva</h2>
      <p>
        L&apos;utente si obbliga a manlevare, tenere indenne e difendere DASABO, i suoi amministratori,
        dipendenti e collaboratori da ogni pretesa, azione, sanzione, spesa (comprese le spese legali)
        derivante dall&apos;uso del Servizio da parte dell&apos;utente, dalla violazione dei presenti
        Termini o dalla violazione di normative fiscali, civili o penali applicabili.
      </p>

      <h2>9. Integrazioni di terze parti</h2>
      <p>
        Il Servizio si avvale di soluzioni di terze parti (a titolo esemplificativo: Fatture in
        Cloud di TeamSystem S.p.A., OpenAPI.it, Resend, provider cloud). L&apos;utente riconosce
        che tali fornitori sono <strong>autonomi rispetto a DASABO</strong> e che i relativi termini
        d&apos;uso, tariffe e limiti operativi si applicano direttamente. DASABO non è responsabile
        di modifiche, sospensioni, tariffazioni, indisponibilità o comportamento anomalo di tali
        servizi.
      </p>

      <h2>10. Corrispettivi</h2>
      <p>
        L&apos;utilizzo del Servizio è subordinato al pagamento del corrispettivo indicato in fase
        di iscrizione. I piani sono venduti nella modalità &laquo;una tantum&raquo; e includono un
        determinato numero di autofatture; superata la soglia è necessario acquistare un nuovo
        pacchetto. <strong>Non sono ammessi rimborsi</strong> se non nei limiti tassativi previsti
        dalla normativa consumeristica applicabile ai contratti B2C conclusi a distanza (nel
        caso in cui l&apos;utente sia qualificabile come consumatore).
      </p>

      <h2>11. Diritto di recesso (solo consumatori)</h2>
      <p>
        L&apos;utente qualificabile come <strong>consumatore</strong> ai sensi del D.Lgs. 206/2005
        può recedere entro 14 giorni dall&apos;iscrizione, salvo che abbia iniziato l&apos;utilizzo
        effettivo del Servizio (upload di almeno un PDF o generazione di XML), nel qual caso il
        diritto di recesso si intende definitivamente esaurito ai sensi dell&apos;art. 59 del
        Codice del Consumo, avendo l&apos;utente espressamente richiesto l&apos;esecuzione
        immediata della prestazione.
      </p>

      <h2>12. Modifiche</h2>
      <p>
        DASABO si riserva il diritto di modificare i presenti Termini in qualsiasi momento,
        dandone comunicazione via email o mediante pubblicazione sul sito. L&apos;uso continuato
        del Servizio dopo la comunicazione costituisce accettazione delle modifiche.
      </p>

      <h2>13. Sospensione e chiusura account</h2>
      <p>
        DASABO può sospendere o chiudere l&apos;account in caso di: violazione dei Termini,
        uso improprio del Servizio, tentativi di reverse engineering, abuso delle risorse
        computazionali, richiesta illegittima di dati di terzi o comportamento fraudolento.
        La chiusura non dà diritto ad alcun rimborso.
      </p>

      <h2>14. Proprietà intellettuale</h2>
      <p>
        Software, marchi, testi, layout, codice sorgente, prompt engineering, template XML e ogni
        altra componente del Servizio sono di titolarità esclusiva di DASABO o dei suoi licenzianti.
        All&apos;utente è concessa una licenza personale, non esclusiva, non trasferibile e revocabile
        di uso del Servizio. È vietata qualsiasi forma di rivendita, sublicenza, decompilazione,
        creazione di opere derivate o utilizzo per addestramento di modelli AI concorrenti.
      </p>

      <h2>15. Trattamento dei dati</h2>
      <p>
        Il trattamento dei dati personali è disciplinato dalla nostra
        <a href="/privacy" className="text-[#1D4ED8] hover:underline"> Privacy Policy </a>
        e dalla nostra
        <a href="/gdpr" className="text-[#1D4ED8] hover:underline"> informativa GDPR</a>,
        parte integrante dei presenti Termini.
      </p>

      <h2>16. Legge applicabile e foro competente</h2>
      <p>
        I presenti Termini sono regolati dalla legge italiana. Per ogni controversia relativa
        all&apos;interpretazione, esecuzione o risoluzione dei presenti Termini sarà
        <strong> esclusivamente competente il Foro di Palermo</strong>, fatta salva la competenza
        inderogabile del foro del consumatore ai sensi del D.Lgs. 206/2005 laddove
        l&apos;utente rivesta tale qualifica.
      </p>

      <h2>17. Clausola di salvaguardia</h2>
      <p>
        Qualora una clausola dei presenti Termini fosse dichiarata nulla o inefficace, essa dovrà
        intendersi sostituita di diritto dalla disposizione di legge più prossima alla volontà
        originaria delle parti, senza che ciò comporti la nullità dell&apos;intero contratto.
      </p>

      <div className="callout">
        <p>
          Per ogni comunicazione formale relativa ai presenti Termini, l&apos;utente può scrivere
          all&apos;indirizzo PEC <strong>dasabo@pec.it</strong> o all&apos;indirizzo email
          <strong> support@dasabo.com</strong>. Le comunicazioni ordinarie relative all&apos;operatività
          del Servizio possono essere inviate esclusivamente all&apos;email di supporto.
        </p>
      </div>
    </LegalLayout>
  );
}
